export default __webpack_public_path__ + "static/media/IMG-2739.4dc033e6.jpg";